import React from 'react'

import Alert from 'components/ui/alert'
import InlineLink from 'components/ui/inline-link'

const ReportsDisabledAlert = (): React.ReactNode => (
  <Alert icon="warning" status="warning">
    Reports let you generate{' '}
    <InlineLink
      to="https://support.disco.ac/home/insights-guide#generating-reports"
      target="_blank"
      rel="noopener noreferrer"
    >
      powerful insights
    </InlineLink>{' '}
    on your activity in DISCO. To access reports{' '}
    <InlineLink to="/settings/billing">upgrade.</InlineLink>
  </Alert>
)

export default ReportsDisabledAlert
